module.exports = __webpack_public_path__ + "static/media/digital.e5ed023f.png";